<section #scroller id="checkout-wrapper">
  <h3>Checkout</h3>

  <div class="flex membership-upsell" *ngIf="qualifiesForMembershipUpsell">
    <div class="upsell-icon gold">
      <div class="wwm-icon"></div>
      Gold
    </div>
    <div class="upsell-block">
      <h6>Save by Becoming a Member</h6>
      <p>
        Sign up for Gold Membership to get discounts on purchases from Written Word Media, including today’s purchase.
      </p>
      <a (click)="openMembershipUpsell()">Learn More</a>
    </div>
    <div class="upsell-price">
      Upgrade now<br>
      $125/yr
    </div>
    <button (click)="addSubscriptionToCart()">Add to Cart</button>
  </div>
  <div *ngIf="order && order.items && order.items.length">
    <div class="item-content" *ngFor="let item of order.items">
      <div class="standard">
        <app-cart-event [item]="item" *ngIf="item.itemType === 'event'" variant="checkoutItem"></app-cart-event>
        <app-cart-subscription [item]="item" *ngIf="item.itemType === 'subscription'" variant="checkoutItem"></app-cart-subscription>
        <app-cart-feature [qualifiesForMembershipUpsell]="qualifiesForMembershipUpsell" [item]="item" *ngIf="item.itemType === 'featuredBook'" variant="checkoutItem"></app-cart-feature>
        <app-cart-promo-stack [qualifiesForMembershipUpsell]="qualifiesForMembershipUpsell" [item]="item" *ngIf="item.itemType === 'promoStack'" variant="checkoutItem"></app-cart-promo-stack>
      </div>
      <div class="mobile">
        <app-cart-event-nugget [item]="item" *ngIf="item.itemType === 'event'" variant="checkoutItem"></app-cart-event-nugget>
        <app-cart-subscription-nugget [item]="item" *ngIf="item.itemType === 'subscription'" variant="checkoutItem"></app-cart-subscription-nugget>
        <app-cart-feature-nugget [item]="item" *ngIf="item.itemType === 'featuredBook'" variant="checkoutItem"></app-cart-feature-nugget>
        <app-cart-promo-stack-nugget [item]="item" *ngIf="item.itemType === 'promoStack'" variant="checkoutItem"></app-cart-promo-stack-nugget>
      </div>
    </div>
    <div class="order-total flex">
      Total
      <span class="quantity flex-grow-1" *ngIf="order && order.items && order.items.length">
        ({{order.items.length}} item{{order.items.length > 1 ? 's' : ''}})
      </span>
      <p class="total-amount">${{orderTotalAmount.toFixed(2)}}</p>
    </div>
  </div>
  <div class="block" *ngIf="order && order.items && order.items.length">
    <app-stripe-form
      [cartPurchaseEnabled]="cartPurchaseEnabled"
      *ngIf="orderTotalAmount > 0"
      [info]="order.purchaserInfo"
      [inProgress]="paymentInProgress"
      (soldOutEvent)="handleSoldOut($event)"
      (paymentStatus)="handlePaymentStatus($event)"
      (paymentSuccess)="handlePaymentSuccess($event)"
    ></app-stripe-form>
    <div class="free-payment" *ngIf="orderTotalAmount === 0">
      <button type="button" class="button regular solid-green submit-free-purchase" (click)="freePurchase()">
        {{paymentInProgress ? 'Submitting Purchase' : 'Complete Purchase'}}
      </button>
    </div>
  </div>
  <div *ngIf="!order || !order.items || !order.items.length">
    <div *ngIf="updateInProgress || loadingOrder; else emptyCart">
      <app-spinner></app-spinner>
    </div>
  
    <ng-template #emptyCart>
      <div>
        <p class="empty" >Your cart is empty!</p>
        <button type='button' class="regular button solid-green" (click)="startOver()">Purchase A Feature</button>
      </div>
    </ng-template>
  </div>

  <div *ngIf="paymentInProgress" class="processing-payment-container">
    <app-spinner [zoom]="0.75" label="{{purchaseInProgressMessage}} (do not refresh your page)" [labelFontSize]="1.6"></app-spinner>
  </div>
</section>
<app-error-modal 
  [modalId]="'cart-error-modal'" 
  [title]="errorTitle" 
  [text]="errorText" 
  [soldOutExtra]="errorExtra" 
  [soldOut]="soldOut" 
  (soldOutEvent)="handleSoldOut($event)"></app-error-modal>

<app-new-error-modal [options]="errorOptions" [textList]="errorExtra" modalId="cart-error-modal"></app-new-error-modal>

<app-modal id="duplicate-order-modal">
    You found a bug! This crafty critter is preventing you from completing your purchase. 
    Don't worry -  please email us at hello&#64;writtenwordmedia.com, and we'll get you back on track.  Apologies for the inconvenience.
</app-modal>

<app-modal id="membership-upsell-modal">
  <aside class="modal">
    <div class="modal-body">
      <div class="header">
        <div class="title-text" >Want to save 10% on all promos?</div>
        <div class="close" (click)="closeMembershipUpsell()"><span class="icon">&#x00D7;</span></div>
      </div>
      <div class="upsell-block">
        <p>
          You can save 10% on all promos (including today’s purchase) by upgrading to a Gold  Membership. 
          Saving 10% is only the beginning, there’s a host of other member benefits waiting for you!
        </p>
        <h6>Membership Benefits</h6>
        <ul>
          <li>10% off all promos</li>
          <li>Early access to inventory, book before anyone else!</li>
          <li>Discounts on partner products, exclusive content and more!</li>
        </ul>
      </div>
      <div class="flex flex-column">
        <button class="button regular solid-green full-width" (click)="addSubscriptionToCart()">Add a Gold Membership</button>
        <button class="button regular outline-green full-width" (click)="closeMembershipUpsell()">No Thanks</button>
      </div>
      
    </div>
  </aside>
  <div class="modal-background"></div>
</app-modal>

<app-modal id="membership-removal-confirmation">
  <aside class="modal">
    <div class="modal-body">
      <div class="header">
        <div class="title-text" >Are you sure?</div>
        <div class="close" (click)="closeMembershipRemovalConfirm()"><span class="icon">&#x00D7;</span></div>
      </div>
      <div class="upsell-block">
        By removing the Gold Membership from your cart, all member benefits will also be removed. This includes:
        <ul>
          <li>Your 10% discount on promotions</li>
          <li>Any Gold & Platinum Member exclusive promotions in your cart such as Limelight</li>
          <li>Promos booked for dates only available to Gold and Platinum members.</li>
        </ul>
      </div>
      <div class="flex gap-20">
        <button class="button regular solid-green full-width" (click)="closeMembershipRemovalConfirm()">Keep my Gold Membership in My Cart</button>
        <button class="button regular outline-green" >I'm sure.</button>
      </div>
      
    </div>
  </aside>
  <div class="modal-background"></div>
</app-modal>
